import api from 'core/api';

export const salesUsersChannelsModule = 'salesUsersChannels';

const loadingStates = {
  start: { loading: true },
  error: { loading: false },
  success: { loading: false },
};

const loadingFormStates = {
  start: { loadingForm: true },
  error: { loadingForm: false },
  success: { loadingForm: false },
};

const actions = {
  setUserAsSales: {
    module: salesUsersChannelsModule,
    name: 'setUserAsSales',
    api: (data) => api.post(`/admin/sales_users_channels/set_user_as_sales`, data),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingFormStates,
  },

  getSalesReport: {
    module: salesUsersChannelsModule,
    name: 'getSalesReport',
    api: (params) => api.get(`/admin/sales_users_channels/report`, { params }),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingStates,
  },
  create: {
    module: salesUsersChannelsModule,
    name: 'create',
    api: (data) => api.post(`/admin/sales_users_channels`, data),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingFormStates,
  },
  update: {
    module: salesUsersChannelsModule,
    name: 'update',
    api: (data) => api.put(`/admin/sales_users_channels/${data?.id}`, data),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingFormStates,
  },
  show: {
    module: salesUsersChannelsModule,
    name: 'show',
    api: (data) =>
      api.get(`/admin/sales_users_channels/${data?.id}`, { params: { userId: data?.userId } }),
    params: {
      start: ['params'],
      error: [''],
      success: [''],
    },
    state: loadingFormStates,
  },
};

const salesUsersChannelsReducer = {
  actions,
  state: {
    loading: false,
  },
};

export default salesUsersChannelsReducer;
